<template>


  <div class="container container-tabs">

    <el-tabs v-model="activeName" @tab-click="handleClick" type="card">

      <el-tab-pane name="all" class="to-searh">
        <span slot="label" class="table-title">全部</span>
      </el-tab-pane>

      <el-tab-pane :name="String(item.val)" v-for="(item, index) in value_status_array" :key="index" class="to-searh">
        <span slot="label" class="table-title">{{ item.alias }}</span>
      </el-tab-pane>







      <div>

        <el-button @click="add_isShow=!add_isShow">添加</el-button>
        <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

      </div>

    </el-tabs>


    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">

      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <div class="more-style">

              <el-form-item label="创建详细时间:">
                <span>{{ props.row.time.YmdHis }}</span>
              </el-form-item>

            </div>
          </el-form>
        </template>
      </el-table-column>





      <el-table-column prop="id" label="id" min-width="80">
      </el-table-column>
      <el-table-column prop="title" label="满减说明" min-width="150">
      </el-table-column>
      <el-table-column prop="full_day" label="满减条件（天）" min-width="150">
      </el-table-column>
      <el-table-column prop="sub_amount" label="满减金额（元）" min-width="150">
      </el-table-column>
      <el-table-column prop="insurance_num" label="预存保险费（单）" min-width="150">
      </el-table-column>
      <el-table-column prop="city.name" label="城市信息" min-width="150">
      </el-table-column>
      <el-table-column prop="time.Ymd" label="创建时间" min-width="150">
      </el-table-column>



      <el-table-column label="管理状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status.val=='0'?'warning':(scope.row.status.val=='1'?'':'danger')">
            {{scope.row.status.alias}}</el-tag>
        </template>
      </el-table-column>



      <el-table-column label="操作" width="150">
        <template slot-scope="scope">

          <el-dropdown split-button trigger="click" type="primary"
            @click="edit_isShow = !edit_isShow; driver_code_children = scope.row.driver_signing_preferential_code; ">

            编辑

            <el-dropdown-menu slot="dropdown">

              <el-dropdown-item @click.native="del(scope.row.driver_signing_preferential_code)">删除</el-dropdown-item>

            </el-dropdown-menu>

          </el-dropdown>

        </template>
      </el-table-column>



    </el-table>


    <!-- 分页组件 -->
    <div class="pagination">

      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>

    <!-- 添加组件 -->
    <addSigningPreferential :isShow="add_isShow" @onSubmit="signingPreferentialLists"></addSigningPreferential>

    <!-- 编辑组件 -->
    <editSigningPreferential :isShow="edit_isShow" :data="driver_code_children" @onSubmit="signingPreferentialLists">
    </editSigningPreferential>


  </div>


</template>

<script>
  var _this;
  import addSigningPreferential from './addSigningPreferential.vue';
  import editSigningPreferential from './editSigningPreferential.vue';


  export default {
    components: {
      addSigningPreferential,
      editSigningPreferential,

    },
    data() {
      return {

        // 选项卡默认选中项
        activeName: 'all',

        // 传入子组件的数据
        driver_code_children: '',




        // 抽屉开关按钮
        edit_isShow: false,
        add_isShow: false,


        // 下拉搜索管理状态
        value_status_code: '',
        value_status_array: [],

        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          status: ''
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          }
        },
      };
    },
    created() {
      _this = this;
      _this.signingPreferentialLists();
    },

    methods: {

      del(code) {

        _this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

          confirmButtonText: '确定',

          cancelButtonText: '取消',

          type: 'warning',

        }).then(() => {

          _this.$post(
            "/driver/deleteSigningPreferentialSubmit", {
              driver_signing_preferential_code: code
            }
          )
          .then(res => {

            _this.signingPreferentialLists();

            _this.$message.success(res.msg);

          }).catch((err) => {

          })


        }).catch(() => {

        });





      },
      
      // 选项卡选中事件
      handleClick(tab, event) {
        // 点击的选项卡所对应的val值
        console.log(tab.name);
        if (tab.name != 'all') {
          _this.search_data.status = tab.name;
        } else {
          _this.search_data.status = '';
        }
        _this.search_data.page = 1;
        _this.signingPreferentialLists();

      },

      // 搜索司机列表
      signingPreferentialLists() {
        _this.$post(
            "/driver/signingPreferentialLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;

            _this.value_status_array = _this.tableData[0].status.select_array;

          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.signingPreferentialLists();

      },

      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },

    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    max-width: 150px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-dropdown {
    vertical-align: top;
  }

  .el-dropdown+.el-dropdown {
    margin-left: 15px;
  }

  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>